import i18n from 'i18next';
import layoputEn from '../translations/en/layoutT.json';
import layoputEs from '../translations/es/layoutT.json';
import homeEn from '../translations/en/home.json';
import homeEs from '../translations/es/home.json';
import userEn from '../translations/en/users.json';
import userEs from '../translations/es/users.json';
import userFormEn from '../translations/en/userForm.json';
import userFormEs from '../translations/es/userForm.json';
import establishmentsEs from '../translations/es/establishments.json';
import establishmentsEn from '../translations/en/establishments.json';
import userCommunicationEs from '../translations/es/communications.json';
import userCommunicationEn from '../translations/en/communications.json';
import contentEn from '../translations/en/content.json';
import contentEs from '../translations/es/content.json';
import roleEs from '../translations/es/role.json';
import roleEn from '../translations/en/role.json';
import presentacionesEs from '../translations/es/presentaciones.json';
import presentacionesEn from '../translations/en/presentaciones.json';
import presentacionesRarEs from '../translations/es/presentacionesRar.json';
import presentacionesRarEn from '../translations/en/presentacionesRar.json';
import organismsEn from '../translations/en/organisms.json';
import organismsEs from '../translations/es/organisms.json';
import validationsEn from '../translations/en/validations.json';
import validationsEs from '../translations/es/validations.json';
import employeesEn from '../translations/en/employees.json';
import employeesEs from '../translations/es/employees.json';
import helpCenterEn from '../translations/en/helpCenter.json';
import helpCenterEs from '../translations/es/helpCenter.json';
import workPositionsEn from '../translations/en/workPositions.json';
import workPositionsEs from '../translations/es/workPositions.json';
import filesGenerationSRTEn from '../translations/en/filesGenerationSRT.json';
import filesGenerationSRTEs from '../translations/es/filesGenerationSRT.json';
import commonEn from '../translations/en/common.json';
import commonEs from '../translations/es/common.json';
import visitasEn from '../translations/en/visitas.json';
import visitasEs from '../translations/es/visitas.json';
import carcinogenicReportEn from '../translations/en/carcinogenicReport.json';
import carcinogenicReportEs from '../translations/es/carcinogenicReport.json';
import periodicosEn from '../translations/en/periodicos.json';
import periodicosEs from '../translations/es/periodicos.json';
import avisoObraEs from '../translations/es/avisoObra.json';
import avisoObraEn from '../translations/en/avisoObra.json';
import contractsEs from '../translations/es/contracts.json';
import contractsEn from '../translations/en/contracts.json';
import providersEs from '../translations/es/providers.json';
import providersEn from '../translations/en/providers.json';
import establishmentDetailsEs from '../translations/es/establishmentDetails.json';
import establishmentDetailsEn from '../translations/en/establishmentDetails.json';
import siniestrosRoamEs from '../translations/es/siniestrosRoam.json';
import siniestrosRoamEn from '../translations/en/siniestrosRoam.json';
import asistenteIAEs from '../translations/es/asistenteIA.json';
import asistenteIAEn from '../translations/en/asistenteIA.json';
import auditoriaFacturacionEs from '../translations/es/auditoriaFacturacion.json';
import auditoriaFacturacionEn from '../translations/en/auditoriaFacturacion.json';


i18n.init({
    debug: false,
    interpolation: { escapeValue: false },
    lng: 'es',
    resources: {
        es: {
            layoutT: layoputEs,
            home: homeEs,
            users: userEs,
            userForm: userFormEs,
            communications: userCommunicationEs,
            content: contentEs,
            roles: roleEs,
            establishments: establishmentsEs,
            presentacionesRar: presentacionesRarEs,
            presentaciones: presentacionesEs,
            organisms: organismsEs,
            validations: validationsEs,
            employees: employeesEs,
            helpCenter: helpCenterEs,
            workPositions: workPositionsEs,
            filesGenerationSRT: filesGenerationSRTEs,
            common: commonEs,
            visitas: visitasEs,
            carcinogenicReport: carcinogenicReportEs,
            periodicos: periodicosEs,
            avisoObra: avisoObraEs,
            contracts: contractsEs,
            providers: providersEs,
            establishmentDetails: establishmentDetailsEs,
            siniestrosRoam: siniestrosRoamEs,
            asistenteIA: asistenteIAEs,
            auditoriaFacturacion: auditoriaFacturacionEs
        },
        en: {
            layoutT: layoputEn,
            home: homeEn,
            users: userEn,
            userForm: userFormEn,
            communications: userCommunicationEn,
            content: contentEn,
            roles: roleEn,
            establishments: establishmentsEn,
            presentacionesRar: presentacionesRarEn,
            presentaciones: presentacionesEn,
            organisms: organismsEn,
            validations: validationsEn,
            employees: employeesEn,
            helpCenter: helpCenterEn,
            workPositions: workPositionsEn,
            filesGenerationSRT: filesGenerationSRTEn,
            common: commonEn,
            visitas: visitasEn,
            carcinogenicReport: carcinogenicReportEn,
            periodicos: periodicosEn,
            avisoObra: avisoObraEn,
            contracts: contractsEn,
            providers: providersEn,
            establishmentDetails: establishmentDetailsEn,
            siniestrosRoam: siniestrosRoamEn,
            asistenteIA: asistenteIAEn,
            auditoriaFacturacion: auditoriaFacturacionEn
        }
    }
});

export default i18n;
